import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function MobileBar() {
  const { t } = useI18n();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  return (
    <div className="lg:hidden fixed bottom-4 inset-x-0 z-40 px-4 pointer-events-none">
      <Link
        to="/disponibilites"
        data-testid="mobile-fixed-availability-btn"
        className="pointer-events-auto flex items-center justify-center gap-2 mx-auto w-full max-w-sm rounded-full bg-brand text-white py-3.5 font-medium text-base shadow-[0_10px_30px_rgba(20,128,179,0.45)] active:scale-[0.98] transition-transform"
      >
        <Calendar size={18} strokeWidth={1.75} />
        {t("common.seeAvailability")}
      </Link>
    </div>
  );
}
